export default { 
  "ORDERBOX_COLUMNS": 3,
  "ORDERBOXES": 6,
  "ORDERBOXES_FILLBOTTOM_FIRST": true,
  
  "THEME_LOGO": "images/logo_missmiu_pink.png",
  "THEME_PAYMENT_ARROW": 'images/arrowDown-missmiu.svg',

  
}
